import { createFileRoute } from '@tanstack/react-router'
import { adjustmentSearchSchema } from '../../../features/inventory/search'
import { StockAdjustmentsListPage } from '../../../features/inventory/stock-adjustments-list-page'

export const Route = createFileRoute('/_app/stock-adjustments/')({
  validateSearch: adjustmentSearchSchema,
  component: StockAdjustmentsListPage,
})
